import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.body.classList.add("reveal-ready");
    const sections = Array.from(document.querySelectorAll("main section")).slice(1);
    sections.forEach((s) => {
      s.classList.add("reveal-watch");
      s.querySelectorAll(".grid").forEach((g) => {
        Array.from(g.children).forEach((c, i) => {
          c.style.transitionDelay = `${Math.min(i, 8) * 70}ms`;
        });
      });
    });
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.04 }
    );
    sections.forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, [pathname]);

  return null;
}
